import React from "react";
import img from "../../Assets/Images/PageHeader_bg.png";

const PageHeader = ({ title }) => {
  return (
    <div
      className="w-full h-[180px] sm:h-[200px] md:h-[220px] lg:h-[260px] xl:h-[300px] bg-cover bg-center bg-no-repeat relative"
      style={{ backgroundImage: `url(${img})` }}
    >
      {/* Overlay */}
      <div className="absolute inset-0 bg-black bg-opacity-40 flex items-center px-4 sm:px-8 md:px-12 lg:px-20">
        {/* Title */}
        <h1
          className="text-white font-orbitron font-semibold 
          text-lg sm:text-2xl md:text-3xl lg:text-4xl xl:text-5xl text-left leading-snug"
        >
          {title}
        </h1>
      </div>
    </div>
  );
};

export default PageHeader;
